import React, { useState, useEffect } from 'react'
import { DataProvider, NavTabs, PosPage, PosSectionMain } from '../../../components-pos'
import { NavLinks } from '../Index-Setting'

export default function SystemIndex(props) {
  return <DataProvider {...props} Component={Index__} />
}

function Index__(props) {
  // useEffect(() => {
  //   document.body.requestFullscreen()
  // }, [])
  return (
    <PosPage>
      <NavLinks {...props} />
      <NavTabs {...props} size="150px" variant="secondary">
        <Comp1 {...props} name="매장공통" />
        <Comp2 {...props} name="매장등록" />
      </NavTabs>
    </PosPage>
  )
}

function Comp1(props) {
  return (
    <PosSectionMain>
      <p>매장 공통</p>
    </PosSectionMain>
  )
}

function Comp2(props) {
  return (
    <PosSectionMain>
      <p>매장 등록</p>
    </PosSectionMain>
  )
}
